module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/article-6881226b6d2af527eacc0b353f5ca2a3.svg";